/**
* @ngdoc directive
* @name No Data
*
* @description
  Block with "no data" message visible when page has no data
*
* @scope
* @param {String} title
* @param {String} subtitle
* @param {String} subtitle2
*
* @example
  <nodata
    title='This folder is empty'
    subtitle='No files are available in this folder.'
    subtitle2='You can drag and drop a file into this folder or add a file or folder using the icons above.'>
  </nodata>

*/

(function () {
  'use strict';

  directive.$inject = ["PATH"];
  app.directive('nodata', directive);

  function directive(PATH) {
    return {
      restrict: 'E',
      scope: {
        title: '@',
        subtitle: '@',
        subtitle2: '@?'
      },
      transclude: true,
      templateUrl: PATH.components + 'nodata/template.html'
    };
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/nodata/directive.js